import { render, staticRenderFns } from "./PackageManagement.vue?vue&type=template&id=4535ef46&scoped=true"
import script from "./PackageManagement.vue?vue&type=script&lang=js"
export * from "./PackageManagement.vue?vue&type=script&lang=js"
import style0 from "./PackageManagement.vue?vue&type=style&index=0&id=4535ef46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535ef46",
  null
  
)

export default component.exports